<template>
    <div class="form">
        <el-form :model="info" ref="info" label-width="100px" label-position="left" class="demo-info">
             <h3 class="sub-title">基础设置</h3>
            <el-form-item label="活动名称：" prop="name">
                <el-input v-model="info.name" :disabled="true" clearable placeholder="请输入活动名称，不超过20个字"></el-input>
            </el-form-item>
            <el-form-item label="活动时间：" prop="date">
                <el-date-picker
                    v-model="info.date"
                    style="width: 100%"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="expireTimeOption"
                    :disabled="true"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item label="返现方式：" prop="type">
                <el-radio-group v-model="info.type" :disabled="true">
                    <el-radio label="1">返还现金</el-radio>
                    <p class="tip">返还现金为部分退款给用户</p>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="返现金额：" class="df">
                <el-input
                    v-model="info.reward_share"
                    :disabled="true"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    style="width: 180px"
                >
                    <template slot="append">%</template>
                </el-input>
                <span style="margin: 0 12px">或</span>
                <el-input
                    v-model="info.reward_cash"
                    :disabled="true"
                    oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                    style="width: 180px"
                >
                    <template slot="append">元</template>
                </el-input>
            </el-form-item>
            <el-form-item label="返现规则：" prop="rule_type" class="df">
                <el-radio-group v-model="info.rule_type" :disabled="true">
                    <el-radio label="1">不限制返现次数</el-radio>
                    <el-radio label="2">限制每人总次数</el-radio>
                    <el-input v-model="info.limit_order_num" :disabled="true" oninput="value=value.replace(/[^\d]/g,'')" style="width: 180px" v-show="info.rule_type == 2">
                        <template slot="append">次</template></el-input
                    >
                </el-radio-group>
            </el-form-item>
            <el-form-item label="返现条件：">
                <p>订单支付完成 7 天内，未申请退款</p>
            </el-form-item>
            <!-- <el-form-item label="活动商品：">
                        <el-button type="primary" @click="showGoods" size="small" style="margin-right: 12px">添加</el-button>
                        <span v-if="count">已添加 {{ count }} 个商品</span>
                    </el-form-item> -->
            <el-form-item label="优惠叠加：" prop="coupon_type">
                <el-radio-group v-model="info.coupon_type" :disabled="true">
                    <el-radio label="1">不叠加其他营销活动或优惠券</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
export default {
    data() {
        return {
            expireTimeOption: {
                disabledDate(date) {
                    //disabledDate 文档上：设置禁用状态，参数为当前日期，要求返回 Boolean
                    return date.getTime() < Date.now() - 24 * 60 * 60 * 1000;
                },
            },
        };
    },
    props: {
        info: {
            type: Object,
           default:()=>{
                return {}
            },
        },
    },
};
</script>

<style lang="scss" scoped>
.form {
    padding: 40px 60px;
    width: 80%;
}
::v-deep .el-range-editor.is-disabled input,
::v-deep .el-input.is-disabled .el-input__inner,
::v-deep .el-radio__input.is-disabled + span.el-radio__label {
    color: #666;
}
.sub-title {
    margin: 60px 0 40px;
    font-size: 18px;
    color: #333;
    margin-right: 10px;
    padding-left: 12px;
    position: relative;
      &:first-child {
        margin-top: 0;
    }
    &::before {
        content: "";
        width: 3px;
        height: 18px;
        background: #2448ff;
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
    }
}

</style>